/**
 * 招待ページ - エラー状態
 */

import { Button } from "components/ui/Button";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";

type InvitationErrorProps = {
  error: { status: number; message: string } | null;
};

export const InvitationError: FC<InvitationErrorProps> = ({ error }) => {
  const navigate = useNavigate();
  const isNotFound = error?.status === 404;
  const isExpired = error?.status === 410;

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-base-200 px-4">
      <div className="card w-full max-w-lg bg-base-100 shadow-xl mx-auto">
        <div className="card-body items-center text-center">
          <div className="text-warning text-5xl mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-16 h-16"
              role="img"
              aria-label="警告アイコン"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
              />
            </svg>
          </div>
          <h1 className="card-title text-2xl">
            {isNotFound || isExpired
              ? "招待が見つかりません"
              : "エラーが発生しました"}
          </h1>
          <p className="text-base-content/70 mb-6">
            {isExpired
              ? "この招待リンクは既に使用済みまたは期限切れです。"
              : isNotFound
                ? "この招待リンクは無効です。"
                : error?.message || "招待情報の取得に失敗しました。"}
          </p>
          <Button type="button" onClick={() => navigate("/")}>
            トップページへ
          </Button>
        </div>
      </div>
    </div>
  );
};
